export default __webpack_public_path__ + "media/images/icons/premium-2b61d3fa80ac492f4a490dc6f1b095a1.svg";